import { DragDropChangeValue, If } from "components";
import { moveElementInArray } from "helpers";
import { useBoolean } from "hooks";
import { OfferDetailsModal } from "modules/offers";
import { useState } from "react";
import { ItemsTableDragDrop } from "ui";

import { useBanner, useBannersReorder } from "../../apis";
import { IBanner } from "../../banners.types";
import { CreateBannerModal, DeleteBannerModal } from "../../features";
import { useBannersColumns } from "../../hooks";
import { BannersTableProps } from "./BannersTable.types";

import styles from "./BannersTable.module.scss";

const BannersTable = ({
  bannersList,
  sorting,
  setSorting,
  isLoading,
  isDragDisabled,
  setBanners
}: BannersTableProps) => {
  const [bannerId, setBannerId] = useState<string | undefined>(undefined);

  const bannersReorder = useBannersReorder();

  const { banner, isLoading: isLoadingBanner } = useBanner(bannerId);

  const {
    value: isOpenBannerModal,
    setTrue: onOpenBannerModal,
    setFalse: onCloseBannerModal
  } = useBoolean();

  const {
    value: isOpenBannerDetailsModal,
    setTrue: onOpenBannerDetailsModal,
    setFalse: onCloseBannerDetailsModal
  } = useBoolean();

  const {
    value: isOpenDeleteModal,
    setTrue: onOpenDeleteModal,
    setFalse: onCloseDeleteModal
  } = useBoolean();

  const { columns } = useBannersColumns({
    isDragDisabled,
    onOpenEdit: onOpenBannerModal,
    onOpenDelete: onOpenDeleteModal,
    setBannerId
  });

  const onRowClick = (row: IBanner) => {
    setBannerId(row.id);
    onOpenBannerDetailsModal();
  };

  const onChangeBannerPriority = (value: DragDropChangeValue) => {
    const { draggableId, toKeyForReorder, fromIndex, toIndex } = value;

    setBanners(
      moveElementInArray({
        array: bannersList,
        keyForReorder: "order",
        fromIndex,
        toIndex
      })
    );

    bannersReorder.mutate({
      bannerId: draggableId,
      newOrder: toKeyForReorder !== undefined ? toKeyForReorder : toIndex
    });
  };

  return (
    <>
      <ItemsTableDragDrop
        className={styles.banners_table}
        columns={columns}
        data={bannersList}
        sorting={sorting}
        setSorting={setSorting}
        isLoading={isLoading}
        skeletonHeight={65}
        onRowClick={onRowClick}
        droppableId={"bannersList"}
        keyForReorder={"order"}
        onChange={onChangeBannerPriority}
        isDragDisabled={isDragDisabled}
      />

      <If condition={isOpenBannerModal}>
        <CreateBannerModal
          bannerId={bannerId}
          isOpen
          onClose={onCloseBannerModal}
        />
      </If>

      <If condition={isOpenDeleteModal}>
        <DeleteBannerModal
          bannerId={bannerId}
          isOpen
          onClose={onCloseDeleteModal}
        />
      </If>

      <If condition={isOpenBannerDetailsModal}>
        <OfferDetailsModal
          isOpen
          onDelete={onOpenDeleteModal}
          onEdit={onOpenBannerModal}
          onClose={onCloseBannerDetailsModal}
          sharedData={banner}
          isLoadingData={isLoadingBanner}
          bannerType="Banner"
        />
      </If>
    </>
  );
};

export default BannersTable;
